import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { EvaluationSubmissionGoal } from '@treams/treams-network';
import { FlexGap, Modal, Popover, Tabs, tokens } from '@treams/treams-ui';

import GoalSelectorItem from '../../../packages/@treams/treams-app/src/components/goals/GoalSelectorItem';

type Props = {
	goals: EvaluationSubmissionGoal[];
	selectedGoalsProp: EvaluationSubmissionGoal[];
	onClose: () => void;
	onSave: (selectedGoals: EvaluationSubmissionGoal[]) => void;
};

const SelectGoalsModal: FC<Props> = ({ goals, selectedGoalsProp, onClose, onSave }) => {
	const { t } = useTranslation();

	const [tab, setTab] = useState(0);

	const finishedGoals = goals.filter((goal) => goal.progress === 1);
	const unfinishedGoals = goals.filter((goal) => goal.progress !== 1);
	const tabGoals = tab === 0 ? unfinishedGoals : finishedGoals;

	const [selectedGoals, setSelectedGoals] = useState<EvaluationSubmissionGoal[]>(selectedGoalsProp);

	const updateSelectedState = (goal: EvaluationSubmissionGoal) => {
		setSelectedGoals((prevItems) => {
			const goalExists = prevItems.some((selectedGoal) => selectedGoal.goal.id === goal.goal.id);
			return goalExists
				? prevItems.filter((item) => item.goal.id !== goal.goal.id)
				: [...prevItems, goal];
		});
	};

	return (
		<Popover.Target
			visible
			center
			onDismiss={onClose}
			contents={
				<Modal>
					<Modal.Header title={t('select.goals.modal.title')} onClose={onClose} />
					<Modal.Contents>
						<Tabs>
							<Tabs.Item
								selected={tab === 0}
								title={t('select.goals.modal.unfinishedTitle')}
								onClick={() => setTab(0)}
							/>
							<Tabs.Item
								selected={tab === 1}
								title={t('select.goals.modal.finishedTitle')}
								onClick={() => setTab(1)}
							/>
						</Tabs>
						<FlexGap flexDirection="column" gap={tokens.gap.list} mt={`${tokens.gap.list}px`}>
							{tabGoals.map((goal) => (
								<GoalSelectorItem
									key={goal.goal.id}
									goal={goal}
									selected={selectedGoals.some(
										(selectedGoal) => selectedGoal.goal.id === goal.goal.id,
									)}
									onChange={() => updateSelectedState(goal)}
								/>
							))}
						</FlexGap>
					</Modal.Contents>
					<Modal.FormFooter
						onCancel={onClose}
						onSave={() => onSave(selectedGoals)}
						saveTitle={t('select.goals.modal.button')}
					/>
				</Modal>
			}
		></Popover.Target>
	);
};

export default SelectGoalsModal;
